/**
 * Copilot route guardrail:
 * Keep this resolver aligned with backend page context routing in
 * codeer/copilot/services/page_contexts.py. Query-string driven pages, such as
 * workspace history (`tab=conversations`), need explicit coverage so Copilot
 * receives the correct page context after frontend route refactors.
 */
export function getCopilotPageKey(
  pathname: string,
  search = ""
): string | undefined {
  if (/^\/workspaces\/[^/]+\/agents\/new(?:\/.*)?$/.test(pathname)) {
    return "workspace.agent_playground.new_agent"
  }
  if (/^\/workspaces\/[^/]+\/agents\/[^/]+\/evaluation$/.test(pathname)) {
    return "workspace.agent_evaluation"
  }
  if (/^\/workspaces\/[^/]+\/agents\/[^/]+$/.test(pathname)) {
    if (new URLSearchParams(search).get("tab") === "evaluation") {
      return "workspace.agent_evaluation"
    }
    return "workspace.agent_playground"
  }
  if (/^\/workspaces\/[^/]+$/.test(pathname)) {
    const params = new URLSearchParams(search)
    if (params.get("tab") === "conversations") {
      return "workspace.history"
    }
  }
  if (/^\/workspaces\/[^/]+\/histories\/[^/]+$/.test(pathname)) {
    return "workspace.history"
  }
  // Add more mappings as needed
  return undefined
}
